import { ALERT_STATUS } from '@app/account-opening-module/enums';
import { IApiAlert } from '@app/account-opening-module/interfaces';
import { FlowRule } from '@models';

export class FlowScreeningModel {
  public alertId: number;
  public alertResponse: object[]; // response from Senzing or any other response here
  public status: ALERT_STATUS;
  public statusDescription: string;
  public errorDescription: string; // information if error happened during flow step
  public rule: FlowRule;
  // right now details exist just fro biometric identification response
  public details: { score: number, selfieImage: string };

  constructor(data: Partial<FlowScreeningModel>) {
    this.alertId = data ? data.alertId : null;
    this.status = data ? data.status : null;
    this.errorDescription = data ? data.errorDescription : null;
    this.statusDescription = data ? data.statusDescription : '';
    this.alertResponse = data && Array.isArray(data.alertResponse) ? [...data.alertResponse] : [];
    this.rule = data ? new FlowRule(data.rule) : new FlowRule();
    this.details = data && data.details ? {...data.details} : null;
  }

  public get isOpenCorpsResponse(): boolean {
    if (!this.alertResponse.length) {
      return false;
    }

    return this.alertResponse
      && this.alertResponse.every(a => Boolean(a['results']))
      && this.alertResponse.every(a => Boolean(a['api_version']));
  }

  public get isSenzingResponse(): boolean {
    if (!this.alertResponse.length) {
      return false;
    }

    return Array.isArray(this.alertResponse)
      && this.alertResponse.every(a => Boolean(a['featureScores']))
      && this.alertResponse.every(a => Boolean(a['features']));
  }

  public get socureScore(): number {
    return this.isSocureResponce ? this.alertResponse[0]['score'] : 0;
  }

  public get biometricScore(): number {
    return this.details ? this.details.score : 0;
  }

  public get biometricSelfie(): string {
    return this.details ? this.details.selfieImage : '';
  }

  public get isSocureResponce(): boolean {
    if (!this.alertResponse.length) {
      return false;
    }

    return Array.isArray(this.alertResponse)
      && this.alertResponse.every(a => Object.keys(a).includes('score') && !Object.keys(a).includes('status'));
  }

  public get isBiometricResponce(): boolean {
    if (!this.details) {
      return false;
    }

    return Object.keys(this.details).some(key => key === 'score');
  }

  public get passed(): boolean {
    return this.status === ALERT_STATUS.PASS;
  }

  public get error(): boolean {
    return this.status === ALERT_STATUS.ERROR;
  }

  public get failed(): boolean {
    return this.status === ALERT_STATUS.FAIL;
  }

  public get skipped(): boolean {
    return this.status === ALERT_STATUS.SKIPPED;
  }

  public get hasErrorDetails(): boolean {
    return Boolean(this.errorDescription);
  }

  public static Deserialize(apiData: IApiAlert): FlowScreeningModel {
    let alertResponse = [];
    if (apiData.alertResponse) {
      alertResponse = Array.isArray(apiData.alertResponse) ? [...apiData.alertResponse] : [apiData.alertResponse];
    }
    const data: Partial<FlowScreeningModel> = {
      alertId: apiData.alertId,
      alertResponse: alertResponse,
      status: apiData.status,
      errorDescription: apiData.errorDescription,
      statusDescription: apiData.statusDescription,
      rule: FlowRule.Deserialize(apiData.rule),
      details: apiData.details
        ? {...apiData.details, score: isNaN(Number(apiData.details.score)) ? 0 : Number(apiData.details.score) } : null
    };

    return new FlowScreeningModel(data);
  }

  public static DeserializeList(apiData: IApiAlert[]): FlowScreeningModel[] {
    if (!Array.isArray(apiData)) {
      return [];
    }

    return apiData.map(a => FlowScreeningModel.Deserialize(a));
  }
}
